import { render } from "./StateOwner.vue?vue&type=template&id=347c2a40"
import script from "./StateOwner.vue?vue&type=script&lang=js"
export * from "./StateOwner.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vattenfall\\vattenfall-klickstrecke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__